










































































import {
  defineComponent,
  computed,
  ref,
  PropType,
  onMounted,
  watch,
} from '@vue/composition-api';
import { VideoPlayback, VideoPreload } from './types';

declare global {
  interface Window {
    dataLayer: any[];
  }
}

// TODO refactor component and remove props/attrs not being used
export default defineComponent({
  name: 'Video',
  inheritAttrs: false,
  props: {
    videoKey: {
      type: String,
      default: null,
    },
    firstFrameImageUrl: {
      type: String,
      required: true,
      default: null,
    },
    isOverlay: {
      type: Boolean,
      default: false,
    },
    videoMuted: {
      type: Boolean,
      default: true,
    },
    isBackground: {
      type: Boolean,
      default: false,
    },
    videoPlayback: {
      type: String as PropType<VideoPlayback>,
      default: 'auto' as VideoPlayback,
      validator: (value: string) => ['auto', 'onHover', 'onClick', 'none'].includes(value),
    },
    controls: {
      type: Boolean,
      default: false,
    },
    hasPlayIcon: {
      type: Boolean,
      default: false,
    },
    hasPauseIcon: {
      type: Boolean,
      default: false,
    },
    rounded: {
      type: Boolean,
      default: false,
    },
    preload: {
      type: String as PropType<VideoPreload>,
      default: 'metadata' as VideoPreload,
      validator: (value: string) => ['none', 'metadata', 'auto'].includes(value),
    },
    showMuteButton: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const videoRef = ref<HTMLVideoElement>();
    const videoPaused = ref(true);

    onMounted(() => {

    });

    const isMuted = ref(props.videoMuted);

    const toggleMute = () => {
      isMuted.value = !isMuted.value;
      if (videoRef.value) {
        videoRef.value.muted = isMuted.value;
      }
    };

    const playVideo = async () => {
      if (!videoRef.value?.paused) return;

      await videoRef.value?.play();
    };

    const pauseVideo = () => {
      videoRef.value?.pause();
    };

    const videoBindings = computed(() => ({
      poster: props.firstFrameImageUrl,
      preload: props.preload,
      muted: isMuted.value,
      ...props.videoKey ? { key: props.videoKey } : {},
      ...props.controls ? { controls: true } : {},
    }));

    watch(() => props.videoPlayback, (newVal) => {
      if (newVal === 'auto') {
        playVideo();
      } else {
        pauseVideo();
      }
    });

    return {
      handleVideo() {
        if (videoPaused.value) {
          playVideo();
        } else {
          pauseVideo();
        }
        videoPaused.value = !!videoRef.value?.paused;
      },
      handleVideoPlaying() {
        videoPaused.value = !!videoRef.value?.paused;
      },
      async handleClick() {
        if (props.videoPlayback === 'onClick') {
          await playVideo();
        }
      },
      async handleMouseOver() {
        if (props.videoPlayback === 'onHover') {
          await playVideo();
        }
      },
      handleMouseOut() {
        if (props.videoPlayback === 'onHover') {
          pauseVideo();
        }
      },
      videoRef,
      videoBindings,
      showPlayIcon: computed(() => (!videoPaused.value ? false : props.hasPlayIcon)),
      showPauseIcon: computed(() => (videoPaused.value ? false : props.hasPauseIcon)),
      getContainerClass: computed(() => {
        const wrapperClass= props.isBackground ? 'video__wrapper--background' : 'video__wrapper';
        return {
          [wrapperClass]: true,
          'video-rounded': props.rounded,
        };
      }),
      isAutoPlayback: computed(() => (props.videoPlayback === 'auto' ? 'true' : null)),
      isMuted,
      toggleMute,
    };
  },
});
